import React from 'react'
import { trackEvent } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { getMostRecentFieldValue } from '@fs/zion-sls'
import InfoSectionHeader from './InfoSectionHeader'
import RowWrapper from '../../ui/RowWrapper'
import FieldDisplay from './FieldDisplay'
import Subsection from './Subsection'
import FieldWrapper from '../../ui/FieldWrapper'
import NoDataAddedMessage from './NoDataAddedMessage'

const OtherFieldsSection = ({ isRestrictedOtherField, disableEdit, openOverlay, otherFields }) => {
  const { t } = useTranslation()
  return (
    <>
      <InfoSectionHeader
        element={{
          label: t('view-index.additional-fields.title', 'Additional Fields'),
          elementType: 'other-fields',
        }}
        disabled={isRestrictedOtherField || disableEdit}
        onEditClick={() => {
          openOverlay('editOtherFields')
          trackEvent({
            event_name: 'click_action',
            link_name: `Edit: Other Fields: Open`,
          })
        }}
      />
      {otherFields.length > 0 && (
        <RowWrapper>
          {otherFields
            .filter((field) => {
              return field?.fieldType !== 'MISC_IMAGE_FOLDER_1950_CENSUS' && field?.fieldType !== 'IMAGE_DIMENSIONS'
            })
            .map(
              (field) =>
                field?.typeData?.displayable && (
                  <FieldDisplay key={field.id} field={field} value={getMostRecentFieldValue(field)} />
                )
            )}
        </RowWrapper>
      )}
      {otherFields.length === 0 && (
        <Subsection>
          <FieldWrapper>
            <NoDataAddedMessage />
          </FieldWrapper>
        </Subsection>
      )}
    </>
  )
}

export default OtherFieldsSection
